import { render } from "./BasicTemplate.vue?vue&type=template&id=441d1b89&scoped=true"
import script from "./BasicTemplate.vue?vue&type=script&lang=js"
export * from "./BasicTemplate.vue?vue&type=script&lang=js"

import "./BasicTemplate.vue?vue&type=style&index=0&id=441d1b89&scoped=true&lang=css"

import exportComponent from "C:\\tapfactor-max\\tapfactor\\frontend_tapfactor\\tapfactorprofile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-441d1b89"]])

export default __exports__